import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Button, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { BaseApiService } from "../../../services/base";
import { DTOModel } from "../../../models/base/dto-model";
import { STOModel } from "../../../models/base/sto-model";

import { toastifyResponse } from "../../../utils/toastify-response/toastify-response";

import { DeleteButton, IconDeleteButton } from "./styles";
export interface PropToChange {
  propName: string;
  propValue: any;
}

interface Props {
  items: DTOModel[];
  itemName?: string;
  serviceApiInstance: BaseApiService<DTOModel, STOModel>;
  handleReload?: () => Promise<void>;
  changeInsteadDelete?: PropToChange;
  isMutated?: React.MutableRefObject<boolean>;
  updateGlobalStateCallback?: () => Promise<void>;
  disableCustomLogic?: any;
  notifyParent?: (ids: string[]) => void;
  disabled?: boolean;
  buttonText?: boolean;
  useIcon?: boolean;
}

const RemoveItem = ({
  items,
  itemName,
  serviceApiInstance,
  handleReload,
  changeInsteadDelete,
  isMutated,
  updateGlobalStateCallback,
  disableCustomLogic,
  disabled = false,
  notifyParent,
  buttonText = false,
  useIcon = false,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.remove_item";

  const [disable, setDisable] = useState<boolean>(false);

  useEffect(() => {
    if (disableCustomLogic) {
      items.forEach((item) => setDisable(disableCustomLogic(item)));
    }
  }, [disableCustomLogic, items]);

  const deleteItem = async () => {
    const confirmed = !!items
      ? window.confirm(
          (itemName ? itemName + "\r\n" : "") + t(`components.window_confirm_modal.multiple_delete_question`)
        )
      : window.confirm((itemName ? itemName + "\r\n" : "") + t(`components.window_confirm_modal.delete_question`));
    if (confirmed && !!items) {
      let toSave: STOModel[] = items;
      if (changeInsteadDelete) {
        toSave = items.map((item) => ({
          ...item,
          [changeInsteadDelete.propName]: changeInsteadDelete.propValue,
        }));
      } else {
        toSave = items.map((item) => ({ ...item, isDeleted: true }));
      }

      const response = await serviceApiInstance.saveItems(toSave);

      if (!response.error) {
        if (isMutated) {
          isMutated.current = true;
        }
        handleReload && (await handleReload());
        updateGlobalStateCallback && updateGlobalStateCallback();
        notifyParent && notifyParent(items.map((item) => item.id));
      }

      toastifyResponse(response);
    }
  };

  const constantInItems = useCallback((): boolean => {
    return items.filter((_item) => _item.isConstant).length > 0;
  }, [items]);

  return (
    <>
      {/* <DeleteButton
        onClick={()=>setState((state)=>({...state, open: true}))}
        title={t(`buttons.delete`)}
        disabled={disabled || constantInItems()}
      >
        {!item?.isConstant && (<FontAwesomeIcon icon={faTrash} />)} 
       <FontAwesomeIcon icon={faTrash} />
      </DeleteButton>
      <MessageContainer
        open={controlledOpen ?? state.open}
        anchorReference={'anchorPosition'}
        anchorPosition={{
          left: width/2 - 200, 
          top: height -100
        }}
        onClose={()=>{setState((state)=>({...state, open:false}))}}
       > */}
      {/* <IconButton
          onClick={()=>{setState((state)=>({...state, open:false}))}}
        >
          <CloseIcon/>  
        </IconButton>   */}
      {/* {items.length === 1 
            ? <Typography>1 {`${t(`${tRP}.selected_item`)}`}</Typography>
            : <Typography>{` ${items.length} ${t(`${tRP}.selected_items`)}`}</Typography>
          } */}
      {useIcon ? (
        <IconDeleteButton>
          <FontAwesomeIcon icon={faTrash} />
        </IconDeleteButton>
      ) : (
        <DeleteButton
          disabled={disabled || constantInItems() || disable}
          onClick={deleteItem}
          buttonText={buttonText}
        >
          {`${t(`buttons.delete`)}`}
        </DeleteButton>
      )}

      {/* </MessageContainer> */}
    </>
  );
};

export default RemoveItem;
